/*
 * layout.ts — the clearly-defined layout constants for the game board.
 *
 * One static config, expressed in the Stage's fixed "design pixel" space
 * (LAYOUT.design). The Stage scales this whole space to fit the viewport, so
 * these numbers never change at runtime — tweak them here to reshape the board.
 *
 * Consumed directly (imported, not via context) by Stage (design),
 * seat-layout.ts (table/seat/trick ellipses + fan.inset), Seat.tsx (avatar/card
 * sizes + fan), and TrickArea.tsx (card size + table center).
 */

export interface Layout {
  /** Fixed design coordinate space the Stage scales to fit the viewport. */
  design: { w: number; h: number };
  /** Center of the seating ellipse (the table center). */
  table: { cx: number; cy: number };
  /** Ellipse radii the avatars sit on. */
  seat: { radiusX: number; radiusY: number };
  /** Ellipse radii each seat's played (trick) card lands on. */
  trick: { radiusX: number; radiusY: number };
  /** Avatar diameter. */
  avatar: number;
  /** Face-up hand card size. */
  card: { w: number; h: number };
  /** Face-down (opponent) card size. */
  faceDown: { w: number; h: number };
  /** Hand fan: angular spread, card overlap (0..1), and how far toward the
   *  table center the fan sits relative to the seat ellipse (0..1). */
  fan: { spreadDeg: number; overlap: number; insetX: number; insetY: number };
}

export const LAYOUT: Layout = {
  design: { w: 1792, h: 828 },
  table: { cx: 896, cy: 414 },
  seat: { radiusX: 600, radiusY: 358 },
  trick: { radiusX: 180, radiusY: 100 },
  avatar: 120,
  card: { w: 72, h: 103 },
  faceDown: { w: 52, h: 74 },
  fan: { spreadDeg: 26, overlap: 0.4, insetX: 0.8, insetY: 0.7 },
};
